import React, { PropTypes } from 'react';
import {
  RaisedButton,
} from 'material-ui';
import { connect } from 'react-redux';
import { anyPass, call, propEq } from 'ramda';

const SignUpButton = props => {
  const {
    signupFn,
    contractingSignUp,
  } = props;
  const existingCompanyId = contractingSignUp.get('existingCompanyId');
  const saving = contractingSignUp.get('saving');
  const companyType = contractingSignUp.get('companyType');
  return (
    <RaisedButton
      data-cy="createAccount"
      label="Create Account"
      labelStyle={{ color: '#fff' }}
      primary
      onTouchTap={signupFn}
      disabled={saving || call(anyPass([
        propEq('email', "Can't locate email"),
        () => {
          if (companyType === 'Supplier' && !existingCompanyId) {
            if (!contractingSignUp.get('productType')) return true;
            if (!contractingSignUp.get('oneOrMulti')) return true;
          }
          return false;
        },
        () => !contractingSignUp.get('country'),
        propEq('passwordError', true),
        // propEq('confirmPasswordError', true),
        propEq('companyNameError', true),
        propEq('companyTaken', true),
        propEq('termsAccepted', false),
      ]), contractingSignUp.toJS())}
    />
  );
};


const mapStateToProps = ({ contractingSignUp }) => {
  return {
    contractingSignUp,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

SignUpButton.propTypes = {
  signupFn: PropTypes.func,
  contractingSignUp: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpButton);



// WEBPACK FOOTER //
// ./src/app/components/contracting-sign-up/signup-button.jsx